'use client';

import { useParams } from 'next/navigation';
import { z } from 'zod';

export function useValidatedParams<T>(schema: z.ZodSchema<T>) {
  const params = useParams();
  return schema.parse(params);
}
